<template>
  <nav>
    <input
      v-model="checked"
      type="checkbox"
      aria-label="Menu"
    >
    <img src="@/assets/hamburger.svg" alt="">
    <router-link
      class="brand"
      :to="{ name: 'home' }"
      aria-label="Säkerhets-SM, home"
    >
      <span @click="uncheck">
        <PixelText
          text="SSM"
          :scale="2"
          fit
          balanced
        />
      </span>
    </router-link>
    <ul>
      <li
        v-for="route in mainRoutes()"
        :key="route.path"
        :to="route"
      >
        <router-link :to="route">
          <span @click="uncheck">
            {{ route.publicName }}
          </span>
        </router-link>
      </li>
      <li v-if="$store.state.user && $store.state.user.permissions.length">
        <router-link :to="{name: 'admin'}">
          <span @click="uncheck">
            Admin
          </span>
        </router-link>
      </li>
      <li v-if="$store.state.user && $store.state.user.superuser">
        <a href="/django_admin">
          <span>
            Django Admin
          </span>
        </a>
      </li>
    </ul>
    <div class="spacer" />
    <ul>
      <li v-if="$store.state.websockets && !$store.state.archived">
        <span
          class="material-icons websocket"
          :class="{disconnected: !$store.state.connected}"
          :title="$store.state.connected ? 'Websocket connected! All content on the page is up to date, no need to refresh' : 'Websocket disconnected. Attempting to reconnect periodically...'"
        >{{ $store.state.connected ? "power" : "power_off" }}</span>
      </li>
      <li>
        <router-link :to="{ name: 'announcements'}" aria-label="Announcements">
          <span class="material-icons" :class="{unread}">{{ unread ? "notifications_active" : "notifications_none" }}</span>
        </router-link>
      </li>
    </ul>
    <ul v-if="!$store.state.archived">
      <li>
        <router-link
          v-if="!$store.state.user"
          class="button button-primary account"
          :to="{ name: 'signin'}"
        >
          <span @click="uncheck">
            Sign in
          </span>
        </router-link>
        <router-link
          v-else
          class="button account"
          :to="{ name: 'profile'}"
        >
          <span @click="uncheck">
            {{ $store.state.user.username }}
            <span class="material-icons">person</span>
          </span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
// TODO add a clock in the navbar like for watevrctf
import PixelText from '@/components/PixelText.vue'

export default {
    components: {
        PixelText,
    },
    data () {
        return { checked: false }
    },
    computed: {
        unread () {
            if (!this.$store.getters.orderedAnnouncements.length) return false
            return this.$store.state.announcementReadTime < this.$store.getters.orderedAnnouncements[0].time
        },
    },
    methods: {
        mainRoutes () {
            return this.$router.options.routes.filter((r) => {
                return r.publicName
            })
        },
        uncheck () {
            this.checked = false
        },
    },
}
</script>

<style lang="scss" scoped>
.material-icons {
    color: $color-accent;
    cursor: pointer;
}

.websocket {
    cursor: default;
}

.disconnected {
    color: $color-disconnected;
}

.unread {
    color: $color-disconnected;
    animation: blink 1s linear infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

// Ink with the logo's pink, green and cyan along the bottom, like the wargame platform.
nav {
    display: flex;
    position: sticky;
    top: 0;
    z-index: 100;
    min-height: 3.5rem;
    align-items: center;
    padding: 0 0.5rem;
    background-color: rgba($ssm-ink, 0.94);

    &::after {
        content: "";
        position: absolute;
        inset: auto 0 (-$mc-px);
        height: $mc-px;
        background: linear-gradient(90deg, $ssm-pink 0 33.34%, $ssm-green 0 66.67%, $ssm-cyan 0);
    }

    > .brand {
        display: inline-flex;
        align-items: center;
        padding: 0.4rem 0.5rem;

        &:hover {
            animation: none;
        }
    }

    > ul {
        display: flex;
        align-items: center;
        margin: 0;
        padding: 0;
        > li {
            list-style: none;
            padding: 8px 12px;
            .material-icons {
                vertical-align: middle;
            }
            > a {
                color: $color-muted-text;
            }
            > a:hover,
            > a:focus-visible {
                color: $color-white;
                text-decoration: none;
                animation: ssm-jitter 0.25s steps(1, end);
            }
            > a.router-link-active:not(.button) {
                color: $color-accent;
                text-decoration: underline;
                text-decoration-thickness: 2px;
                text-underline-offset: 0.35em;
            }
        }
    }

    .account {
        display: inline-block;
        padding: 0.2rem 0.75rem;

        &.button-primary {
            color: $ssm-ink;
        }

        .material-icons {
            font-size: 1.25rem;
        }
    }

    > .spacer {
        flex: 1 0 auto;
    }
    > input {
        display: none;
    }
    > img {
        display: none;
    }
}

@media only screen and (max-width: 990px) {
    nav {
        flex-direction: column;
        align-items: flex-start;
        height: auto;
        > ul {
            display: none;
            flex-direction: column;
            align-items: flex-start;
        }
        > .brand {
            position: absolute;
            top: 0.25rem;
            left: 50%;
            transform: translateX(-50%);
        }
        > .spacer {
            display: none;
        }
        > input {
            display: block;
            cursor: pointer;
            opacity: 0;
            z-index: 1001;
            width: 32px;
            height: 32px;
            margin: 12px 8px;
        }
        > img {
            display: block;
            position: absolute;
            top: 12px;
            left: 8px;
        }
        > input:checked ~ ul {
            display: flex;
        }
    }
}
</style>
